import React from 'react';

export type EffortTag = 'Quick Win' | 'Moderate' | 'High';

export interface EffortTagPillProps {
  tag: EffortTag;
}

export const EffortTagPill: React.FC<EffortTagPillProps> = ({ tag }) => (
  <span
    className={`text-[10px] font-semibold px-2 py-0.5 rounded border ${
      tag === 'Quick Win'
        ? 'bg-green-50 text-green-700 border-green-200'
        : tag === 'Moderate'
          ? 'bg-amber-50 text-amber-700 border-amber-200'
          : 'bg-rose-50 text-rose-700 border-rose-200'
    }`}
  >
    {tag}
  </span>
);

export default EffortTagPill;
